// Solution based on this thread: https://stackoverflow.com/questions/51504506/too-many-react-context-providers
import { FC, JSXElementConstructor, PropsWithChildren, ReactNode, useEffect } from 'react';
import { initializeSessionToken, openReplayTracker } from 'lib/util';
import { GATSBY_NODE_ENV } from '../util/constants';
import { useAuthStore, useRegistrationStore } from '.';

interface StoreProps {
  providers: Array<JSXElementConstructor<PropsWithChildren<any>>>;
  children: ReactNode;
}

export const Store: FC<StoreProps> = ({ providers = [], children }) => {
  // Stores must be initialized for persistence
  useAuthStore();
  useRegistrationStore();

  useEffect(() => {
    // NOTE: to test the replay tracker locally, temporarily comment out the line below
    // openReplayTracker.start();
    if (GATSBY_NODE_ENV === 'production') {
      openReplayTracker.start().then(({ sessionToken }) => {
        initializeSessionToken(sessionToken);
      });
    }
  }, []);

  return (
    <>
      {providers.reduceRight(
        (acc, Provider) => (
          <Provider>{acc}</Provider>
        ),
        children
      )}
    </>
  );
};
